/**
 * Permission constants. Must stay in sync with
 * pickuphungary-dashboard-api/src/packages/ph-core/src/Constants/Permissions.ts
 */
const Permissions = {
  /** Full financials: revenue, profit, partner/creator tables. Administrator only. */
  CAN_SEE_GLOBAL_STATS: 'CanSeeGlobalStats',

  /** Transfers, experiences, cancellation analytics. AgentHead and above. */
  CAN_SEE_BASIC_STATS: 'CanSeeBasicStats',

  /** Pax & Occupancy section. Agent and above. */
  CAN_SEE_PAX_STATS: 'CanSeePaxStats',

  /** Payments screen: record/list/reassign/refund payments. Agent and above. */
  CAN_INTERACT_WITH_PAYMENTS: 'CanInteractWithPayments',

  /** Month End closing/reconciliation screen. Agent and above. */
  CAN_INTERACT_WITH_MONTH_END: 'CanInteractWithMonthEnd',

  /**
   * The AI Admin area (/ai-admin): everything that CONFIGURES the assistant.
   *
   * Area-level, not per-feature. Today the area holds one section — the
   * knowledge bases (create/delete a base, upload and delete documents,
   * trigger re-ingestion) — and more AI functions and settings are meant to
   * land beside it, inheriting this permission unless a section needs
   * narrower access, in which case it adds its own constant alongside this
   * one. See Pages/AiAdmin/areas.js. Administrator only.
   *
   * ASKING questions is deliberately NOT gated by this — an operator asking
   * "how do I report a no-show?" retrieves ungated through the chat agent.
   * This permission guards MANAGING, nothing else.
   */
  MANAGE_AI: 'ManageAi',
};

export default Permissions;
